<div *ngIf="orderGood" class="order-complete-page" fxLayout="column" fxLayoutAlign="center center">
    <div class="order-complete-card order-complete-card--success" fxLayout="column" fxLayoutAlign="center center">
        <div class="order-complete-header" fxLayout="row wrap" fxLayoutAlign="space-between start">
            <div class="order-complete-header__copy">
                <strong class="order-complete-eyebrow">{{ 'ORDER_CONFIRMATION' | translate }}</strong>
                <h1 class="order-complete-title">{{ 'CONGRATULATIONS' | translate }}</h1>
            </div>
            <div class="order-complete-order-number">{{ 'ORDER_NUMBER_PREFIX' | translate }}{{orderNumber}}</div>
        </div>
        <p class="order-complete-copy">{{ 'ORDER_HAS_BEEN_CONFIRMED' | translate }} {{clientEmail}} {{ 'AND_WILL_FOLLOW_UP_SHORTLY_WITH_NEXT_STEPS' | translate }}</p>
        <mat-icon class="order-complete-icon">newspaper</mat-icon>
        <button type="button" class="blue-button order-complete-link" (click)="downloadInvoice()">{{ 'DOWNLOAD_YOUR_RECEIPT' | translate }}</button>
        <p *ngIf="(nextPay | P_AppDateFormat) !== 'Invalid date'" class="order-complete-next-payment">{{ 'NEXT_PAYMENT' | translate }} {{nextPay | P_AppDateFormat}}</p>
    </div>
</div>

<div *ngIf="!orderGood" class="order-complete-page" fxLayout="column" fxLayoutAlign="space-around center">
    <div fxLayout="column" fxLayoutAlign="center center" class="order-complete-card order-complete-card--error">
        <div class="order-complete-header order-complete-header--error" fxLayout="column" fxLayoutAlign="center center">
            <mat-icon class="order-complete-icon">error_outline</mat-icon>
            <strong class="order-complete-eyebrow">{{ 'ORDER_SAVED' | translate }}</strong>
            <h1 class="order-complete-title">{{ 'PAYMENT_RETRY_NEEDED' | translate }}</h1>
        </div>
        <p class="order-complete-copy">{{ 'ISSUE_PROCESSING_PAYMENT' | translate }} {{orderNumber}}.</p>
        <p class="order-complete-copy">{{ 'VISIT' | translate }} <a href="pages/myaccount/orders" class="blue-button order-complete-link">{{ 'YOUR_ORDERS' | translate }}</a> {{ 'TO_RETRY_PAYMENT' | translate }}</p>
    </div>
</div>
